@if (multi) {
  <ng-container [ngTemplateOutlet]="groupedItem" [ngTemplateOutletContext]="{ $implicit: groupItem$ | async }"> </ng-container>
} @else {
  <ng-container [ngTemplateOutlet]="singleItem" [ngTemplateOutletContext]="{ $implicit: lottoItem }"> </ng-container>
}

<ng-template #groupedItem let-item>
  <div class="card redeem-card py-3 bg-marketplace-wallet cursor-pointer grouped" [ngClass]="{ 'w-btn': item?.count > 1 }">
    <span class="item-count">x{{ item?.count }}</span>
    <div class="d-flex justify-content-center align-items-center">
      <img
        class="purchase-list-image"
        [src]="item?.items[0].Image | contentImage: '7'"
        alt=""
        [useDefault]="true"
        [loyaltyType]="'marketplace'"
        draggable="false"
      />
    </div>

    <div class="marketplace-wallet-won-item-name purchase-title">{{ item?.items[0].Name }}</div>
    <div class="action-wrapper">
      <button class="bg-primary rounded">{{ 'marketplace.purchased.list.item.view.items' | translate }}</button>
    </div>
  </div>
</ng-template>

<ng-template #singleItem let-item>
  <ng-container *ngIf="item">
    @if (!redeemed) {
      @if (orientation === 'portrait') {
        <ng-container *ngTemplateOutlet="portrait; context: { $implicit: item }"></ng-container>
      } @else if (orientation === 'landscape') {
        <div class="d-none d-lg-flex">
          <ng-container *ngTemplateOutlet="landscape; context: { $implicit: item }"></ng-container>
        </div>
        <div class="d-lg-none d-flex">
          <ng-container *ngTemplateOutlet="portrait; context: { $implicit: item }"></ng-container>
        </div>
      }
    } @else {
      <div class="wallet-container redeemed-border p-3 cursor-pointer">
        <div class="row">
          <div class="col-lg-1 col-2 d-flex justify-content-start align-items-center">
            <img
              class="purchase-list-image"
              [src]="item.Image | contentImage: '7'"
              alt=""
              [useDefault]="true"
              [loyaltyType]="'marketplace'"
              draggable="false"
            />
          </div>
          <div class="col-lg-11 col-10">
            <div class="ms-lg-0 ms-3 d-flex flex-column justify-content-between h-100">
              <div class="wallet-lotto-item-name">{{ item.Name }}</div>
              @if (item.RedeemDate) {
                <div class="lotto-wallet-claimed">
                  {{ 'fgbcl.lotto.claimed' | translate }} {{ item?.RedeemDate | UtcToLocaltimePipe: dateOption.ShortDateFormat }}
                </div>
              } @else if (expired()) {
                <fgbcl-expired-pill [ExpirationDate]="item.ExpireDate"></fgbcl-expired-pill>
              }
            </div>
          </div>
        </div>
      </div>
    }
  </ng-container>
</ng-template>

<ng-template #portrait let-item>
  <div
    class="card redeem-card py-3 bg-wallet-lotto cursor-pointer"
    [ngClass]="{ redeemed: item?.RedeemDate, 'w-btn': showButton }"
  >
    <div class="d-flex justify-content-center align-items-center">
      <img
        class="purchase-list-image"
        src="{{ item?.Image | contentImage: '7' }}"
        alt=""
        [useDefault]="true"
        [loyaltyType]="'marketplace'"
        draggable="false"
      />
    </div>
    <div class="lotto-wallet-won-item-name purchase-title">{{ item?.Name }}</div>

    @if (item?.RedeemDate) {
      <div class="lotto-wallet-claimed">
        {{ 'fgbcl.lotto.claimed' | translate }} {{ item?.RedeemDate | UtcToLocaltimePipe: dateOption.ShortDateFormat }}
      </div>
    } @else if (expired()) {
      <fgbcl-expired-pill [ExpirationDate]="item.ExpireDate"></fgbcl-expired-pill>
    } @else {
      <!--Expiration Date-->
      <ng-container *ngIf="item.ExpireDate">
        <div class="marketplace-wallet-expiry">
          {{ 'fgbcl.wallet.expiry.date' | translate }}
          {{ item.ExpireDate | UtcToLocaltimePipe: dateOption.LongDateFormat }}
        </div>
      </ng-container>
    }
    @if (!item?.RedeemDate) {
      <ng-container *ngIf="item.Barcode">
        <div class="d-block d-lg-none mt-auto">
          <div class="qrcode-container">
            @if (!showButton) {
              <qrcode
                [qrdata]="item.Barcode"
                [width]="116"
                [errorCorrectionLevel]="'M'"
                [elementType]="'svg'"
                [margin]="0"
              ></qrcode>

              <span class="marketplace-scan-text">{{ 'lottos.purchased.list.item.scan.text' | translate }}</span>
            } @else {
              <qrcode
                [qrdata]="item.Barcode"
                [width]="83"
                [errorCorrectionLevel]="'M'"
                [elementType]="'svg'"
                [margin]="0"
              ></qrcode>
            }
          </div>
        </div>
      </ng-container>
    }
    <ng-container *ifScreenSize="screenType.Desktop">
      @if (showButton) {
        <div class="action-wrapper">
          <button class="bg-primary rounded marketplace-wallet-view-btn">
            <span class="font-size-14">{{ 'view.rewards.item' | translate }}</span>
          </button>
        </div>
      }
    </ng-container>
  </div>
</ng-template>

<!-- LANDSCAPE VIEW -->
<ng-template #landscape let-item>
  <div class="card wallet-item-card">
    <div class="wallet-item-card-details">
      <img [src]="item.Image | contentImage: '7'" alt="" [useDefault]="true" [loyaltyType]="'wallet'" draggable="false" />
      <div class="wallet-item-details">
        <div class="wallet-item-title">{{ item.Name }}</div>
        @if (item?.RedeemDate) {
          <div class="lotto-wallet-claimed">
            {{ 'fgbcl.lotto.claimed' | translate }} {{ item?.RedeemDate | UtcToLocaltimePipe: dateOption.ShortDateFormat }}
          </div>
        } @else if (expired()) {
          <fgbcl-expired-pill [ExpirationDate]="item.ExpireDate"></fgbcl-expired-pill>
        } @else {
          <!--Expiration Date-->
          <ng-container *ngIf="item.ExpireDate">
            <div class="marketplace-wallet-expiry">
              {{ 'fgbcl.wallet.expiry.date' | translate }}
              {{ item.ExpireDate | UtcToLocaltimePipe: dateOption.LongDateFormat }}
            </div>
          </ng-container>
        }
      </div>
    </div>
    <div class="action-buttons" *ngIf="!item?.RedeemDate && !expired()">
      <span class="marketplace-claim-text">{{ 'lottos.purchased.list.item.claim.text' | translate }}</span>
    </div>
  </div>
</ng-template>
